import React from 'react';
import { useTranslation } from 'react-i18next';
import { ItemCreation } from '~/Components';
import { Typography, Accordion, AccordionDetails, AccordionSummary } from '~/UIKit';
import { makeStyles } from '~/UIKit/Style';
import {
  ExtendedNotificationSettings,
  useUserProfileNotificationSettings,
} from './useUserProfileNotificationSettings';

const useStyles = makeStyles(() => ({
  userProfileNotificationSettingsAccordion: {
    marginTop: 30,
  },
  userProfileNotificationSettingsAccordionDetails: {
    paddingRight: 0,
    paddingLeft: 0,
  },
}));

export const UserProfileNotificationSettings = () => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const {
    listItems,
    headers,
    initialValues,
    error,
    validate,
    isLoading,
  } = useUserProfileNotificationSettings();
  return (
    <Accordion classes={{ root: classes.userProfileNotificationSettingsAccordion }}>
      <AccordionSummary aria-controls="panel1a-content" id="panel1a-header">
        <Typography>{t('settings.updateNotificationSettings')}</Typography>
      </AccordionSummary>
      <AccordionDetails classes={{ root: classes.userProfileNotificationSettingsAccordionDetails }}>
        <ItemCreation<ExtendedNotificationSettings>
          listItems={listItems}
          headers={headers}
          onSave={() => {}}
          initialValues={initialValues}
          validate={validate}
          networkError={error}
          isLoading={isLoading}
        />
      </AccordionDetails>
    </Accordion>
  );
};
